// pvduy 06/01/2021 thêm api lấy dữ liệu cho vị trí địa lý
import BaseAPI from "./base/base-api";

class LocationAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Location";
}

export default new LocationAPI();
